<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card flat tile>
                    <v-card-title>
                        Change Log
                    </v-card-title>

                    <v-card-text>
                        <v-row v-for="(version, versionIndex) in versions" :key="'version-' + versionIndex">
                            <v-col>
                                <div class="title">Version {{ version.title }}</div>
                                <div class="body-2">
                                    <ul>
                                        <li v-for="(item, itemIndex) in version.items"
                                            :key="'item-' + versionIndex + '-' + itemIndex">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    computed: {
      versions() {
        return [
          {
            title: "0.6",
            items: [
              "Introduced the possibility of altering the amount of reserve slots in a game."
            ]
          },
          {
            title: "0.5",
            items: [
              "Started introducing proper Eldritch Horror icons for skills, health and sanity.",
              "Added some colors to the cards to have them set apart a little bit on overview."
            ]
          },
          {
            title: "0.4",
            items: [
              "Introduced investigators so that a player can choose an investigator from the game and get the starting possessions of that investigator.",
              "Enabled a card to be moved directly from one investigator to another.",
              "Corrected functionality of discard piles and decks so that the cards are moved to the correct place upon player defeat and devour.",
              "Enabled changing the investigator order by moving an investigator after another investigator."
            ]
          },
          {
            title: "0.3",
            items: [
              "Changed function of discard piles so that a random card or specific card can be drawn from a discard pile. The function will first try to get card from normal deck. If the card is not found, it will be taken from the discard pile.",
              "Corrected bug where reserve was filling up with assets of game packs not chosen.",
              "Now automatically shuffles the discarded assets in to the asset deck when the asset deck is empty."
            ]
          },
          {
            title: "0.2",
            items: [
              "Introduced card count on game preferences where selecting expansions.",
              "Corrected the amount of cards in the game, some where missing before."
            ]
          },
          {
            title: "0.1",
            items: [
              "Created change log page.",
              "Turned the navigation bar into icons to have navigation more fluent.",
              "Turned game expansion list in game preferences into a checkbox list which makes for a better presentation."
            ]
          }
        ]
      }
    }
  };
</script>
